import { ChannelTypes, EventCategories } from 'redux/reducers/subscriptions';

import { SHOW_BELL_NOTIFICATION } from 'config';

const getChannelTypeAllNames = (): Record<ChannelTypes, string> => {
  if (SHOW_BELL_NOTIFICATION) {
    return {
      on_site: 'OPUS website notifications',
      email_daily_digest: 'Daily e-mail',
      email_weekly_digest: 'Weekly e-mail',
      standalone_email: 'E-mail immediately',
      push: 'Mobile alert immediately',
    };
  } else {
    return {
      email_daily_digest: 'Daily e-mail',
      email_weekly_digest: 'Weekly e-mail',
      standalone_email: 'E-mail immediately',
    };
  }
};
export const channelTypeAllNames = getChannelTypeAllNames();

const getChannelTypeNames = (): Record<ChannelTypes, string> => {
  if (SHOW_BELL_NOTIFICATION) {
    return {
      on_site: 'OPUS website notifications',
      email_daily_digest: 'Daily e-mail',
      email_weekly_digest: 'Weekly e-mail',
    };
  } else {
    return {
      email_daily_digest: 'Daily e-mail',
      email_weekly_digest: 'Weekly e-mail',
    };
  }
};
export const channelTypeNames = getChannelTypeAllNames();

export const channelPriorityAndChartsTypeNames = (
  channel: 'priority' | 'charts'
): Record<any, string> => {
  if (SHOW_BELL_NOTIFICATION) {
    return {
      on_site: 'In the OPUS notification tray',
      standalone_email: 'In an immediate e-mail',
      ...(channel === 'priority'
        ? { push: 'In an immediate mobile alert' }
        : {}),
    };
  } else {
    return {
      standalone_email: 'In an immediate e-mail',
    };
  }
};

export const channelPriorityAndChartsEditTypeNames = (
  channel: 'priority' | 'charts'
): Record<any, string> => {
  if (SHOW_BELL_NOTIFICATION) {
    return {
      on_site: 'In the OPUS notification tray',
      email_daily_digest: 'In an immediate e-mail',
      email_weekly_digest: 'In a weekly e-mail',
      standalone_email: 'In an immediate e-mail',
      ...(channel === 'priority'
        ? { push: 'In an immediate mobile alert' }
        : {}),
    };
  } else {
    return {
      email_daily_digest: 'In an immediate e-mail',
      email_weekly_digest: 'In a weekly e-mail',
      standalone_email: 'In an immediate e-mail',
    };
  }
};

const getChannelTypes = (): Record<ChannelTypes, string> => {
  if (SHOW_BELL_NOTIFICATION) {
    return {
      on_site: 'in OPUS',
      email_daily_digest: 'via daily e-mail',
      email_weekly_digest: 'via weekly e-mail',
      standalone_email: 'immediately via e-mail',
      push: 'immediately mobile alert',
    };
  } else {
    return {
      email_daily_digest: 'via daily e-mail',
      email_weekly_digest: 'via weekly e-mail',
      standalone_email: 'immediately via e-mail',
    };
  }
};
export const channelTypes = getChannelTypes();

export const eventCategoryLabels: Record<EventCategories, string> = {
  thresholds: 'Streaming alerts',
  charts: 'Chart position alerts',
  playlisting: 'Playlist alerts',
  priority: 'Priority Playlist Alerts',
};

export const eventCategoryTooltipTexts: Record<EventCategories, string> = {
  thresholds:
    'Important streaming events for any tracks, releases, or projects.',
  charts:
    'Important chart position activity for any tracks, releases, or projects.',
  playlisting:
    'Important playlist position activity for any tracks, releases, or projects.',
  priority:
    'Get notified only when activity occurs on noteworthy playlists (curated by WMG staff)',
};
